<template>
  <div class="modal" v-bind:class="{ 'is-active': show }">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 70% !important; height: 81% !important;">
      <header class="modal-card-head hero">
        <div class="columns">
          <div class="column is-10">
            <h1 class="title">Comparación</h1>
          </div>
          <div class="column is-2" style="text-align: end">
            <button aria-label="close" class="delete" @click="close"></button>
          </div>
        </div>
      </header>
      <section class="modal-card-body">
        <br>
        <div class="columns">
          <div v-if="Object.keys(process).length > 0" class="column is-6 has-text-centered">
            <h1 class="has-text-dark has-text-weight-bold">{{process.nombre}}</h1>
            <span class="has-text-grey">Proceso #1 a comparar</span>
          </div>
          <div v-if="Object.keys(processComp).length > 0" class="column is-6 has-text-centered">
            <h1 class="has-text-dark has-text-weight-bold">{{processComp.nombre}}</h1>
            <span class="has-text-grey">Proceso #2 a comparar</span>
          </div>
        </div>
        <h1 class='is-size-5' style='margin-top: 30px; margin-bottom: 25px;'><span class='has-text-weight-bold'>Selecciona un proceso</span> para comparar con el actual, el sistema lo ordenará por fecha...</h1>
        <div class="columns">
          <div class="column is-12">
            <div class="columns">
              <div class="column">
                <p class="control has-icons-left has-icons-right">
                  <input
                      class="input is-focused"
                      type="text"
                      v-model="search"
                      placeholder="Filtrar "
                  />
                  <span class="icon is-medium is-left">
                    <i class="material-icons">search</i>
                  </span>
                </p>
              </div>
            </div>
            <div class="is-block scroll-table scroll-light is-white" style='height: 210px!important;'>
              <table class="table is-fullwidth">
                <thead class="head-stick">
                <tr>
                  <th>{{ filteredItems.length }}</th>
                  <th>✓</th>
                  <th>Proceso</th>
                  <th>Creado</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(k,v) in filteredItems" :key="v">
                  <td style="width: 5%">{{ v + 1 }}</td>
                  <td style="width: 5%"><input class="is-dark is-medium" type="radio" :value="k" :name="k" :id="v"
                                               v-model="processComp">
                  </td>
                  <td>{{ k.nombre }}</td>
                  <td>{{dateProcess(k.created)}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="buttons">
          <button v-if="this.process.comparison && Object.keys(this.process.comparison).length > 0" class="button is-danger"
                  @click="deleteComp">
            Eliminar Comparación actual
          </button>
          <button class="button"
                  @click="close">
            Cerrar
          </button>
          <button class="button is-dark" id="btnsave" @click="save">
            Continuar
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
const filterItems = (query, data, process) => {
  return data.filter((el) => {
    const texto = el.nombre
    if (texto.toLowerCase().indexOf(query.toLowerCase()) > -1 && el._id !== process._id) {
      return el
    }
  }).sort(
      (objA, objB) => Number(new Date(objA.created)) - Number(new Date(objB.created)),
  );
};

export default {
  data() {
    return {
      search: "",
      processComp: {},
    }
  },
  computed: {
    filteredItems: function () {
      return filterItems(this.search, this.listProcesses, this.process);
    },
  },
  props: {
    show: Boolean,
    process: Object,
    listProcesses: Array
  },
  methods: {
    close() {
      this.processComp = {}
      this.$emit('closeModalComp')
    },
    save() {
      try {
        if (Object.keys(this.processComp).length > 0 && Object.keys(this.process).length > 0) {
          this.$emit('selected', this.process, this.processComp)
        } else {
          this.$store.dispatch("notify", {
            message: `Debes elegir el proceso con el que desea comparar`,
            type: "is-danger",
          });
        }
      } catch (err) {
        console.log(err)
        this.$store.dispatch("notify", {
          message: `Hubo un problema al continuar con el proceso`,
          type: "is-danger",
        });
      }
    },
    async deleteComp(){
      await this.$emit('deleteComparison', this.process._id)
    },
    dateProcess(d) {
      let date = new Date(d)
      let options = {year: 'numeric', month: 'numeric', day: 'numeric'}
      date = date.toLocaleDateString(undefined, options)
      return date
    },
  },
  created() {

  },
  watch:{
    show(nv){
      if (nv){
        if (this.process.comparison){
          this.processComp = this.process.comparison
        }
      }
    }
  }
}
</script>

<style>
textarea {
  resize: none;
  overflow: hidden;
  box-shadow: inset 0 0 0 rgb(10 10 10 / 10%);
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalComparacion.vue